// extracted by mini-css-extract-plugin
module.exports = {"StaticFormValue":"StaticFormValue_StaticFormValue__2hWWu","secondary":"StaticFormValue_secondary__30CL_"};